import useResource from "../../../hooks/UseResource";
import * as VisitService from "../../../services/VisitService";

export default function useVisit(id) {
    return useResource(id, VisitService.getVisit);
}
